import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";

const BookingsTemplate = ({
  handlePageChange,
  data,
  count,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Stack
        direction="row"
        alignSelf="start"
        justifyContent="start"
        gap={2}
        width="100%"
      >
        <Breadcrumb data={breadcrumbs} />
      </Stack>
      <CCrud
        table={{
          list: data,
          listTitle: t("events_bookings.list_title"),
          createBtnTitle: false,
          columns: [
            { accessor: "id", Header: "#" },
            {
              accessor: "order_number",
              Header: t("events_bookings.order_number"),
            },
            {
              accessor: "customer_name",
              Header: t("events_bookings.customer"),
            },
            {
              accessor: "event_type_name",
              Header: t("events_bookings.event_type"),
            },
            {
              accessor: "package_name",
              Header: t("events_bookings.package"),
            },
            {
              accessor: "event_datetime",
              Header: t("events_bookings.event_date"),
            },
            { accessor: "total_label", Header: t("events_bookings.total") },
            {
              accessor: "booking_status_label",
              Header: t("events_bookings.booking_status"),
            },
            {
              accessor: "payment_status_label",
              Header: t("events_bookings.payment_status"),
            },
            { accessor: "Actions", Header: t("cart_logs.actions") },
          ],
          isSearch: true,
          searchInputPlaceholder: t("events_bookings.search_placeholder"),
          isChecked: false,
          total_count: count,
          setFilterObj,
          className: "organization-table main-table",
          paginationPage: paginationPage,
          handlePageChange,
          rowData,
          filterList,
          actionsList,
          emptyListMsg: t("events_bookings.empty"),
        }}
        form={{
          initialValues: {},
          structure: () => [],
          onSubmit: () => {},
        }}
        modalComponents={[]}
      />
    </Box>
  );
};

export default BookingsTemplate;
